<div class="shape-panel__content">
  <div class="shape-panel__tools">

    <div class="shape-panel__shapes">
      <div class="shape-panel__item" (click)="addSquareLayer()">
        <span class="shape-panel__item-square"></span>
      </div>
      <div class="shape-panel__item" (click)="addCircleLayer()">
        <span class="shape-panel__item-circle"></span>
      </div>
      <div class="shape-panel__item" (click)="addTriangleLayer()">
        <span class="shape-panel__item-triangle"></span>
      </div>
      <div class="shape-panel__item" (click)="addLineLayer()">
        <span [ngStyle]="{'font-family': 'monospace'}">/</span>
      </div>
      <div class="shape-panel__item" *ngFor="let symbol of symbols" (click)="addShapeLayer(symbol)">
        <span [ngStyle]="{'font-family': symbol.fontName}">{{ symbol.char }}</span>
      </div>
    </div>
  </div>
  <div class="shape-panel__actions">
    <div [ngStyle]="{'opacity': layerData?.type == 'LineShapeLayer' ? '1' : '0.5', 'pointer-events': layerData?.type == 'LineShapeLayer' ? 'all' : 'none' }">
      <div class="shape-panel__label">{{ 'cfg_shapePanel_thickness' | translate }}</div>
      <input class="shape-panel__slider" type="range" name="lineWidth" min="1" max="30" [(ngModel)]="currentSize">
    </div>
  </div>
</div>
